import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  buildCourseDetailsURI,
  buildCourseModalsURI,
} from "../../../_helpers/utilities";
import RenderRating from "../../Other/StarRating/RenderRating";
import { getS3URL } from "../../../_helpers/utilities";
import CartButton from "./CartButton/CartButton";
import { deleteWishlist, addWishlist } from "../../../_actions/cart.actions";
import { courseActions } from "../../../_actions";
import CourseModal from "./CourseModal";
import "tippy.js/themes/light.css";
import "tippy.js/dist/tippy.css";
import Tippy from "@tippyjs/react";
import moment from "moment/moment";
import "./ToolTip.css";

const CourseTile = ({ post, bundle, demo, hidedata, viewType }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loggedIn } = useSelector((state) => state.authentication);
  const { t } = useTranslation();
  const [modal, setModal] = useState(false);

  const likeHandler = (courseId, isWishlisted) => {
    if (loggedIn && isWishlisted) {
      dispatch(deleteWishlist(courseId));
      dispatch(courseActions.handleResetCourseList());
    } else if (loggedIn && !isWishlisted) {
      dispatch(addWishlist(courseId));
      dispatch(courseActions.handleResetCourseList());
    } else {
      history.push("/login");
    }
  };

  const handleModal = () => {
    setModal(true);
  };

  console.log("post", post);

  return (
    <>
      <Tippy
        theme="light"
        className="tippy"
        interactive={true}
        flipBehavior="flip"
        disabled={viewType === "list" ? true : false}
        placement="right"
        content={
          <div className="tippy-content">
            <div className="tippy-coursename">
              {post.CourseName || post.name}
            </div>
            <div className="topspace">
              <p className="updated-date">
                <div className="courseSellingStatus">Bestseller</div>
                <span> Updated:-</span>
                {!bundle
                  ? moment(post?.CreatedOn).format("MMM DD, YYYY")
                  : moment(post?.createdAt).format("MMM DD, YYYY")}
              </p>
            </div>
            <div className="topspace">
              <div>
                <span>
                  {" "}
                  <span className="checkMarkPreview">&#10003;</span>
                  InstructorName :-
                </span>{" "}
                {post?.instructorName}
              </div>
              <div>
                <span>
                  <span className="checkMarkPreview">&#10003;</span>Duration:-
                </span>
                {post.Duration || post.duration} Hours
              </div>
              <div>
                <span>
                  <span className="checkMarkPreview">&#10003;</span>Language:-
                </span>
                {post.Language || " "}
              </div>
              <div>
                <span>
                  <span className="checkMarkPreview">&#10003;</span>Level:-
                </span>
                {post.Level || " "}
              </div>
              <div>
                <span>
                  <span className="checkMarkPreview">&#10003;</span>Price:-
                </span>
                ${post.EnrollmentFee || post.price}
              </div>

              <div className="oneliner">
                {bundle ? (
                  <div
                    dangerouslySetInnerHTML={
                      post.description
                        ? {
                            __html:
                              post.description
                                .replace(/<img .*?>/g, "")
                                .substring(0, 300) + "...",
                          }
                        : {
                            __html: post.description,
                          }
                    }
                  ></div>
                ) : (
                  <div
                    dangerouslySetInnerHTML={
                      post.Description
                        ? {
                            __html:
                              post.Description.replace(
                                /<img .*?>/g,
                                ""
                              ).substring(0, 300) + "...",
                          }
                        : {
                            __html: post.Description,
                          }
                    }
                  ></div>
                )}
              </div>
            </div>
            <div className="navigationPreview">
              <Link
                to={
                  !bundle
                    ? buildCourseDetailsURI(
                        post.Category,
                        post.CourseName,
                        post.ID
                      )
                    : buildCourseDetailsURI("", post.name, post.id, post.id)
                }
                className="btn-edit-content startCourse"
              >
                More Info
              </Link>
            </div>
          </div>
        }
      >
        {bundle ? (
          <div className="post" key={demo ? post : post.id.toString()}>
            <div className="image-wrapper">
              {demo ? (
                <img src={post?.imageLink} alt="" />
              ) : (
                <Link
                  aria-label="Course Details"
                  to={buildCourseDetailsURI("", post.name, post.id, post.id)}
                >
                  <img
                    src={post?.imageLink ? getS3URL(post.imageLink) : ""}
                    alt=""
                  />
                </Link>
              )}
            </div>

            <div className="tile-content">
              {demo ? (
                <div className="tile-header">{post?.name}</div>
              ) : (
                <Link
                  aria-label="Course Details"
                  to={buildCourseDetailsURI("", post.name, post.id, post.id)}
                >
                  <div className="tile-header">{post?.name}</div>
                </Link>
              )}

              <div className="container-wrap">
                <RenderRating ratings={Number(0)} />
                <div className="price-wrapper">
                  <span
                    className="price"
                    style={post?.isPurchased ? { opacity: "0.5" } : null}
                  >
                    {post.price !== null ? `${post.price}   ` : null}
                  </span>
                </div>
              </div>

              <div className="button-wrapper">
                <div className="">
                  <Link
                  // to={
                  //   demo
                  //     ? ""
                  //     : buildCourseDetailsURI("", post.name, post.id, post.id)
                  // }
                  >
                    <span>{t("moreInfo")}</span>
                  </Link>
                </div>

                <div>
                  <CartButton post={{ ...post, ID: post.id }} bundle={bundle} />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="post" key={post.ID.toString()}>
            <div className="image-wrapper">
              {!post.isPurchased && (
                <div
                  className="icon-wrapper"
                  onClick={() => likeHandler(post.ID, post?.isWishlisted)}
                >
                  <span
                    className={`icon ${
                      !post?.isWishlisted ? "icon-like" : "icon-liked"
                    } `}
                  ></span>
                </div>
              )}

              <div
                className={`${
                  post.Category === null ? "category-null" : "category"
                }`}
              >
                {post.Category}
              </div>

              <img
                src={
                  post?.imageFiles?.length > 0
                    ? getS3URL(post.imageFiles[0].fileName)
                    : post.fileName
                    ? getS3URL(post?.fileName)
                    : ""
                }
                alt=""
              />
            </div>
            <div className="tile-content">
              <div className="tile-header">
                <div className="tile-heading">
                  {" "}
                  {post.CourseName}
                  {/* {!hidedata && (
                    <p className="preview-modal" onClick={handleModal}>
                      Preview
                    </p>
                  )} */}
                  {/* {modal && <CourseModal post={post} setModal={setModal} />} */}
                </div>
              </div>
              <div className="auth-title">{post.instructorName}</div>

              <div className="container-wrap">
                <RenderRating ratings={Number(post.rating)} />
                <div className="price-wrapper">
                  <span
                    className="price"
                    style={post.isPurchased ? { opacity: "0.5" } : null}
                  >
                    {post.EnrollmentFee !== null
                      ? `${post.EnrollmentFee}   `
                      : null}
                  </span>
                </div>
              </div>

              <div className="button-wrapper">
                <div className="">
                  <Link
                    to={{
                      pathname: buildCourseDetailsURI(
                        post.Category,
                        post.CourseName,
                        post.ID
                      ),
                    }}
                  >
                    <span>{t("moreInfo")}</span>
                  </Link>
                </div>
                {!post.isExperienced && (
                  <div>
                    <CartButton post={post} />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Tippy>
    </>
  );
};

export default CourseTile;
